import { render, staticRenderFns } from "./FavoriteAuctionListItems.vue?vue&type=template&id=2f94eb5a&scoped=true&"
import script from "./FavoriteAuctionListItems.vue?vue&type=script&lang=js&"
export * from "./FavoriteAuctionListItems.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteAuctionListItems.vue?vue&type=style&index=0&id=2f94eb5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f94eb5a",
  null
  
)

export default component.exports